// src/features/auth/authSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import apiClient from "../../services/axiosClient";

export const loginUser = createAsyncThunk(
  "auth/loginUser",
  async ({ encryptPayload1, navigate }, { rejectWithValue }) => {
    try {
      const response = await apiClient.post("/login", {
        token: encryptPayload1,
      });

      localStorage.setItem("auth_token", response.data.access_token);
      localStorage.setItem("first_name", response.data.name);
      localStorage.setItem("last_name", response.data.surname);

      navigate("/", { replace: true });
      return response.data;
    } catch (err) {
      const message =
        err?.response?.data?.message || err.message || "Login failed";

      return rejectWithValue(message);
    }
  },
);

export const oauthLogin = createAsyncThunk(
  "auth/oauthLogin",
  async ({ agentic_access_token, navigate }, { rejectWithValue }) => {
    try {
      const response = await apiClient.post("/exchange", {
        agentic_access_token: agentic_access_token,
      });

      // Store JWT and user info
      localStorage.setItem("auth_token", response.data.access_token);
      localStorage.setItem("first_name", response.data.name ?? "");
      localStorage.setItem("last_name", response.data.surname ?? "");

      // if (response.data.name) {
      //   localStorage.setItem("first_name", response.data.name);
      // }
      // if (response.data.surname) {
      //   localStorage.setItem("last_name", response.data.surname);
      // }

      if (navigate) {
        navigate("/", { replace: true });
      }

      return response.data;
    } catch (err) {
      const message = err?.response || "OAuth login failed";
      return rejectWithValue(message);
    }
  },
);

// Slice
const authSlice = createSlice({
  name: "auth",
  initialState: {
    user: null,
    loading: false,
    error: null,
  },
  reducers: {
    logout(state) {
      state.user = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Traditional login
      .addCase(loginUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload;
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // OAuth login
      .addCase(oauthLogin.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(oauthLogin.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload;
      })
      .addCase(oauthLogin.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { logout } = authSlice.actions;

export const logoutUser = (navigate) => (dispatch) => {
  const logoutRedirectUrl = localStorage.getItem("logout_redirect_url");

  localStorage.removeItem("auth_token");
  localStorage.removeItem("agentic_access_token");
  localStorage.removeItem("refresh_token");
  localStorage.removeItem("first_name");
  localStorage.removeItem("last_name");
  localStorage.removeItem("logout_redirect_url");

  dispatch(logout()); // clears Redux state

  if (logoutRedirectUrl) {
    window.location.href = logoutRedirectUrl;
  } else {
    navigate("/login");
  }
};

export default authSlice.reducer;
